module.exports = __webpack_public_path__ + "img/guotai.2239e214.jpeg";